export type Options =
	| 'cpf'
	| 'cnpj'
	| 'carteirinha'
	| 'date'
	| 'phone'
	| 'phone-without-ddd'
	| 'long-phone'
	| 'hidePhone'
	| 'examCode'
	| 'cep'
	| 'clear';

export const formatMasks = (option: Options, value: string): string => {
	if (!value) return '';

	switch (option) {
		case 'cpf':
			return value
				.replace(/[^\d]+/g, '')
				.replace(/(\d{3})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
		case 'cnpj': {
			const cleanCnpj = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
			const isAlphanumeric = /[A-Z]/.test(cleanCnpj);
			if (isAlphanumeric) {
				return cleanCnpj.replace(
					/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
					'$1.$2.$3/$4-$5',
				);
			}
			return cleanCnpj
				.replace(/(\d{2})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d)/, '$1/$2')
				.replace(/(\d{4})(\d)/, '$1-$2')
				.replace(/(\d{2})(\d)$/, '$1');
		}
		case 'carteirinha':
			return value
				.replace(/[^\w]+/g, '')
				.replace(/^(\w{5})(\w)/, '$1.$2')
				.replace(/\.(\w{6})(\w)/, '.$1/$2')
				.replace(/\/(\w{2})(\w)$/, '/$1-$2')
				.toUpperCase();
		case 'date':
			return value
				.replace(/\D/g, '')
				.replace(/(\d{2})(\d)/, '$1/$2')
				.replace(/(\d{2})(\d)/, '$1/$2')
				.replace(/(\d{4})(\d)$/, '$1');
		case 'phone':
			return value.replace(/\D/g, '').replace(/(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
		case 'phone-without-ddd':
			return value.replace(/\D/g, '').replace(/(\d{4,5})(\d{4})$/, '$1-$2');
		case 'long-phone':
			return value.replace(/\D/g, '').replace(/(\d{4})(\d{3})(\d{4})$/, '$1-$2-$3');
		case 'hidePhone':
			return value.replace(/(\d{2})\d{5}(\d{4})/, '($1)*****-$2');
		case 'examCode':
			return value.replace(/(\w{9})/, '$1');
		case 'cep':
			return value.replace(/\D/g, '').replace(/(\d{5})(\d{3})$/, '$1-$2');
		case 'clear':
			return value.replace(/[^\w]+/g, '');
		default:
			return '';
	}
};
